import * as React from "react";
import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";

export class TimeReminderIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 56 56">
                <g>
                    <rect fill={"none"} width="56" height="56"/>
                    <path fill={"currentColor"}
                          d="M25.333,48.667A23.333,23.333,0,1,1,48.667,25.333,23.333,23.333,0,0,1,25.333,48.667Zm0-44.333a21,21,0,1,0,21,21A21,21,0,0,0,25.333,4.333Z"
                          transform="translate(2.667 2.667)"/>
                    <path fill={"currentColor"}
                          d="M20.163,19.289H19.7L6.63,12.522a1.043,1.043,0,1,1,.933-1.867l12.6,6.3,11.9-7.7a1.4,1.4,0,0,1,1.633.467c.233.467.233,1.167-.233,1.4l-12.6,7.933Z"
                          transform="translate(8.07 12.211)"/>
                </g>
            </SvgIcon>
        );
    }
}

